module.exports = __webpack_public_path__ + "img/carousel-mobile-1.6217ed58.png";